import localstore from 'store/dist/store.modern'

export default localstore
